import { Chart, registerables } from 'chart.js';
import React, { useEffect, useRef } from 'react';

Chart.register(...registerables);

export default function FrequencyTab({ game, sortedByNum, getBarColor, bonusFreq }) {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (!chartRef.current || !sortedByNum.length) return;

    if (chartInstance.current) {
      chartInstance.current.destroy();
      chartInstance.current = null;
    }

    chartInstance.current = new Chart(chartRef.current, {
      type: 'bar',
      data: {
        labels: sortedByNum.map((e) => e.n),
        datasets: [
          {
            data: sortedByNum.map((e) => e.f),
            backgroundColor: sortedByNum.map((e) => getBarColor(e.f)),
            borderWidth: 0,
            borderRadius: 2,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              title: (items) => `Ball #${items[0].label}`,
              label: (item) => `Drawn ${item.raw} times`,
            },
          },
        },
        scales: {
          x: {
            ticks: { font: { size: 10 }, color: '#888', maxRotation: 0, autoSkip: true, maxTicksLimit: 25 },
            grid: { display: false },
          },
          y: {
            ticks: { font: { size: 11 }, color: '#888' },
            grid: { color: 'rgba(128,128,128,0.1)' },
          },
        },
      },
    });

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
        chartInstance.current = null;
      }
    };
  }, [sortedByNum, getBarColor]);

  return (
    <>
      <p className="section-label">Main ball frequency (1-{game.maxMain})</p>
      <div className="chart-wrap">
        <canvas ref={chartRef}></canvas>
      </div>

      <p className="section-label" style={{ marginTop: '1.75rem' }}>
        {game.bonusName} frequency (1-{game.maxBonus})
      </p>
      <div className="bonus-freq-grid">
        {Array.from({ length: game.maxBonus }, (_, i) => i + 1).map((n) => (
          <div className="bonus-freq-item" key={n}>
            <div
              className="bonus-ball-sm"
              style={{
                background: `${game.bonusColor}22`,
                borderColor: game.bonusColor,
                color: game.bonusColor,
              }}
            >
              {n}
            </div>
            <div className="bonus-freq-count">{bonusFreq[n] || 0}x</div>
          </div>
        ))}
      </div>
    </>
  );
}
